export default "__VITE_ASSET__BWQIfDa7__"